import { IMeetingRegisterOptions, IWebinarRegisterOptions } from 'marketing-site/lib/zoom'
import { IMarketoFormValues } from 'marketing-site/src/library/components/MarketoFormV2'
import { IWebinar } from '../../index'

export default function createRegisterParams(
  props: IWebinar,
  values: IMarketoFormValues,
  utmSource: string,
) {
  const commonParams = {
    email: values.Email,
    firstName: values.FirstName,
    lastName: values.LastName,
    org: values.Company,
    utmSource: utmSource,
    customQuestions: values.question ? [{ title: 'Ask a question', value: values.question }] : [],
  }
  if (props.zoomType === 'webinar') {
    return {
      registerUrl: '/api/webinars/register',
      params: {
        webinarId: props.zoomId as string,
        ...commonParams,
      } as IWebinarRegisterOptions,
    }
  }
  return {
    registerUrl: '/api/meetings/register',
    params: {
      meetingId: props.zoomId as string,
      ...commonParams,
    } as IMeetingRegisterOptions,
  }
}
